<template>
  <div>
    <section class="home-slider owl-carousel">
      <div
        class="slider-item"
        style="background-image: url(images/bg_02.jpg)"
        data-stellar-background-ratio="0.5"
      >
        <div class="overlay"></div>
        <div class="container">
          <div
            class="row slider-text justify-content-center align-items-center"
          >
            <div class="col-md-7 col-sm-12 text-center ftco-animate">
              <h1 class="mb-3 mt-5 bread">Product Detail</h1>
              <p class="breadcrumbs">
                <span class="mr-2"><a href="index.html">Home</a></span>
                <span>Product Detail</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="ftco-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 mb-5 ftco-animate">
            <a href="images/menu-2.jpg" class="image-popup"
              ><img
                src="images/menu-2.jpg"
                class="img-fluid"
                alt="Colorlib Template"
            /></a>
          </div>
          <div class="col-lg-6 product-details pl-md-5 ftco-animate">
            <h3>Creamy Latte Coffee</h3>
            <p class="price"><span>$4.90</span></p>
            <p>
              A small river named Duden flows by their place and supplies it
              with the necessary regelialia. It is a paradisematic country, in
              which roasted parts of sentences fly into your mouth.
            </p>
            <p>
              Kashgar or Kashi is an oasis city with approximately 350.000
              residents in the western part of the Xinjiang UyghurAutonomous
              Region of the People’s Republic of China. Kashgar is the
              administrative centre of Kashgar Prefecture which has an area of
              162.000 km and a population of approximately 3.5 million. The city
              covers an area of 15 km. The altitude averages 1.289 m/4.282 ft.
              above sea level. The city is located in the western extremity of
              China. The earliest mention of Kashgar occurs when the Chinese Han
              Dynasty envoy traveled the Northern Silk Road to explore lands to
              the west. Another early mention of Kashgar is during the Former
              Han (aslo known as the Western Han Dynasty), when in 76 BC the
              Chinese conqured the Xionganu, Yutian (Khotan), Sulei (Kashgar),
              and a group of states in the Tarim Basin Almost up to the foot of
              the Tian Shan Mountains. The Uyghurs employed an alphabet based
              upon the Syriac and borrowed from the Nestorian, but after
              converting to Islam widely used also an Arabic script. They spoke
              a dialect of Turkic claimed to be preserved in the KudatkuBilik, a
              moral treatise composed in 1065.
            </p>
            <div class="row mt-4">
              <div class="col-md-6">
                <div class="form-group d-flex">
                  <div class="select-wrap">
                    <div class="icon">
                      <span class="ion-ios-arrow-down"></span>
                    </div>
                    <select name="" id="" class="form-control">
                      <option value="">Small</option>
                      <option value="">Medium</option>
                      <option value="">Large</option>
                      <option value="">Extra Large</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="w-100"></div>
              <div class="input-group col-md-6 d-flex mb-3">
                <span class="input-group-btn mr-2">
                  <button
                    type="button"
                    class="quantity-left-minus btn"
                    data-type="minus"
                    data-field=""
                  >
                    <i class="icon-minus"></i>
                  </button>
                </span>
                <input
                  type="text"
                  id="quantity"
                  name="quantity"
                  class="form-control input-number"
                  value="1"
                  min="1"
                  max="100"
                />
                <span class="input-group-btn ml-2">
                  <button
                    type="button"
                    class="quantity-right-plus btn"
                    data-type="plus"
                    data-field=""
                  >
                    <i class="icon-plus"></i>
                  </button>
                </span>
              </div>
            </div>
            <p>
              <a href="cart.html" class="btn btn-primary py-3 px-5"
                >Add to Cart</a
              >
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="ftco-section">
      <div class="container">
        <div class="row justify-content-center mb-5 pb-3">
          <div class="col-md-7 heading-section ftco-animate text-center">
            <span class="subheading">Discover</span>
            <h2 class="mb-4">Related products</h2>
            <p>
              We share the variety and wonderful taste of Uyghur cuisine with
              its ancient origins and we will be happy with it!
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="menu-entry">
              <a
                class="img"
                style="background-image: url(images/menu-1.jpg)"
              ></a>
              <div class="text text-center pt-4">
                <h3><a>Coffee Capuccino</a></h3>
                <p>
                  A small river named Duden flows by their place and supplies
                </p>
                <p class="price"><span>$5.90</span></p>
                <p>
                  <a class="btn btn-primary btn-outline-primary">Add to Cart</a>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="menu-entry">
              <a
                class="img"
                style="background-image: url(images/menu-2.jpg)"
              ></a>
              <div class="text text-center pt-4">
                <h3><a>Coffee Capuccino</a></h3>
                <p>
                  A small river named Duden flows by their place and supplies
                </p>
                <p class="price"><span>$5.90</span></p>
                <p>
                  <a class="btn btn-primary btn-outline-primary">Add to Cart</a>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="menu-entry">
              <a
                class="img"
                style="background-image: url(images/menu-3.jpg)"
              ></a>
              <div class="text text-center pt-4">
                <h3><a>Coffee Capuccino</a></h3>
                <p>
                  A small river named Duden flows by their place and supplies
                </p>
                <p class="price"><span>$5.90</span></p>
                <p>
                  <a class="btn btn-primary btn-outline-primary">Add to Cart</a>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="menu-entry">
              <a
                class="img"
                style="background-image: url(images/menu-4.jpg)"
              ></a>
              <div class="text text-center pt-4">
                <h3><a>Coffee Capuccino</a></h3>
                <p>
                  A small river named Duden flows by their place and supplies
                </p>
                <p class="price"><span>$5.90</span></p>
                <p>
                  <a class="btn btn-primary btn-outline-primary">Add to Cart</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ProductSingle",
};
</script>

<style scoped></style>
